var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntertainment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H68V68H0V0Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1920_2774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0464 8.5C30.7588 8.97922 33.0907 10.431 35.6084 11.407C36.5532 11.7735 37.5546 12.0307 38.5543 12.2192C39.8972 12.4711 41.1728 12.1646 42.36 11.4916C43.2411 10.9912 43.8073 11.3172 43.8073 12.3214C43.8073 16.0318 43.8002 19.7422 43.8161 23.4544C43.8179 23.9389 43.6463 24.2666 43.2783 24.5608C41.394 26.0707 39.2779 26.3525 37.0504 25.602C35.5288 25.0893 34.0656 24.4004 32.59 23.7574C31.2259 23.1637 29.8759 22.5382 28.3879 22.3021C27.3334 22.1347 26.2913 22.1682 25.2103 22.5347C25.2103 22.2933 25.2103 22.1101 25.2103 21.9286C25.2103 18.264 25.2227 14.5994 25.1979 10.9348C25.1944 10.3041 25.0369 9.67337 24.936 8.93517C25.3536 8.81537 25.9074 8.65856 26.4629 8.5C26.992 8.5 27.5192 8.5 28.0482 8.5H28.0464Z",
    fill: "#D3AA29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.35 39.1133C20.35 40.6302 20.3606 42.0679 20.3323 43.5038C20.3287 43.6429 20.1076 43.805 19.9536 43.9107C18.3754 44.9907 18.3294 46.7878 19.8723 47.9224C20.143 48.1215 20.4508 48.2924 20.7657 48.4104C22.1122 48.9178 23.471 48.9143 24.8156 48.4069C25.1306 48.2871 25.4367 48.1162 25.7091 47.9171C27.2148 46.8107 27.206 45.0295 25.6614 43.9777C25.2987 43.731 25.1978 43.4809 25.2031 43.0756C25.2226 41.4671 25.2208 39.8585 25.2031 38.25C25.1996 37.9029 25.3057 37.7849 25.6561 37.7162C30.5021 36.7683 35.3978 36.5587 40.3129 36.7754C43.0411 36.8952 45.764 37.1594 48.487 37.3902C49.0036 37.4343 49.522 37.5911 50.0139 37.7673C50.5075 37.9452 50.8508 38.3099 50.8702 38.8737C50.8897 39.4322 50.5889 39.8145 50.113 40.0541C49.7556 40.2356 49.3734 40.3695 48.9983 40.5175C48.5808 40.6813 48.1437 40.8046 47.7421 41.002C46.7389 41.4953 46.4045 42.4749 47.0256 43.3998C47.4006 43.9601 47.919 44.515 48.5029 44.8322C49.8175 45.5492 51.2082 46.1271 52.5776 46.7402C53.1561 46.9992 53.763 47.1965 54.3522 47.4344C55.3041 47.8167 56.1215 48.3928 56.8027 49.1592C57.6537 50.1141 57.5546 51.1166 56.5125 51.8583C55.5465 52.5454 54.4265 52.8855 53.2906 53.1427C46.3373 54.7107 39.3044 55.4965 32.1688 55.1882C28.126 55.0137 24.1345 54.4517 20.1854 53.5779C17.9826 53.0916 15.8029 52.5208 13.8496 51.3615C13.0994 50.9157 12.3758 50.3625 11.7866 49.7248C10.311 48.1215 10.2562 46.0531 11.5371 44.2842C12.1918 43.3804 13.0375 42.6827 13.9611 42.0679C15.9108 40.7694 18.0587 39.8955 20.3464 39.1168L20.35 39.1133ZM39.7785 47.9665C39.7785 49.7424 41.2117 51.1853 42.988 51.1941C44.7626 51.2029 46.2223 49.7635 46.2311 47.9964C46.24 46.1905 44.8033 44.7511 42.9951 44.7564C41.2028 44.7617 39.7785 46.1817 39.7785 47.9665Z",
    fill: "#005AA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5845 27.9434C23.5845 33.6641 23.5845 39.3865 23.5845 45.1071C23.5845 45.2304 23.5881 45.3537 23.5845 45.4788C23.5668 46.0074 23.2324 46.3686 22.7706 46.3597C22.323 46.3509 22.0028 46.0021 21.9833 45.4982C21.978 45.3749 21.9833 45.2516 21.9833 45.1265C21.9833 33.6993 21.9833 22.2721 21.9833 10.8449C21.9833 10.7057 21.9798 10.5666 21.9851 10.4274C22.0081 9.91997 22.3301 9.59756 22.799 9.60461C23.259 9.61165 23.5544 9.90235 23.5651 10.408C23.5863 11.6131 23.5987 12.8199 23.6004 14.0268C23.604 18.6657 23.6004 23.3045 23.6004 27.9434H23.5863H23.5845Z",
    fill: "#005AA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1920_2774",
    x: 6.625,
    y: 6.5,
    width: 54.75,
    height: 54.7542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1920_2774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1920_2774",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntertainment);
export default __webpack_public_path__ + "static/media/intertainment.9d6784df2a452d4fc5b98b2db44ecb54.svg";
export { ForwardRef as ReactComponent };